import React, {memo} from 'react';
import styled from 'styled-components';

import {greys, palette} from '../../../../libs/shared/ui/src/styles/colorStyles';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface TextAreaCounterProps {
  textLength: number;
  textLengthLimit: number;
}

/*
 * Style.
 */

const StyledCounterDiv = styled.div`
  font-variant-numeric: tabular-nums;
  float: right;
  display: inline-flex;
  position: absolute;
  right: 8px;
  bottom: 18px;
`;

interface PillStyleProps {
  $isOverLimit: boolean;
}

const StyledPillDiv = styled.div<PillStyleProps>`
  font-size: ${fontSizes.veryTiny};
  color: ${(p) => (p.$isOverLimit ? palette.red.shade40 : greys.shade70)};
`;

/*
 * Component.
 */

export const TextAreaCounter = memo<TextAreaCounterProps>((props) => {
  const {textLength, textLengthLimit} = props;
  const isOverLimit = textLength > textLengthLimit;

  return (
    <StyledCounterDiv>
      <StyledPillDiv $isOverLimit={isOverLimit}>{`${textLength}/${textLengthLimit}`}</StyledPillDiv>
    </StyledCounterDiv>
  );
});
